export default __webpack_public_path__ + "static/media/Z_Zumbi.81a20a06.svg";